import { SidebarMenuItem } from "@volca/ui/components/ui/sidebar";
import type { SettingsNav } from "./use-settings-nav";
import { WorkspaceMenu } from "./workspace-menu";

export const SidebarNavUser = ({
  settings,
  onImpersonate,
}: {
  settings: SettingsNav | null;
  onImpersonate?: () => void;
}) => (
  <SidebarMenuItem>
    <WorkspaceMenu settings={settings} onImpersonate={onImpersonate} />
  </SidebarMenuItem>
);
